export default __webpack_public_path__ + "static/media/regulatory--reversible-lanes--g2.969c0d44.png";